import React, { ErrorInfo, ReactNode } from 'react';

import { getEnvironment, getGwUrl, getSsoUrl, PRE, PROD } from '@config/getEnviroment';
import { log } from '@utils/log';

interface State {
  hasError: boolean;
  error?: any;
}
interface Props {
  children: ReactNode;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error?: any) {
    if (error) {
      return {
        hasError: true,
        error,
      };
    }
    return {
      hasError: true,
      error: false,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const input = [
      {
        message: error.message,
        level: error.name,
        context: JSON.stringify(errorInfo.componentStack),
        section: window.location.href,
      },
    ];
    const url = getGwUrl() || '';
    const mustLogError = () => {
      const isNotFunctionE = /e is not a function/i;
      const isNotFunctionP = /p is not a function/i;
      const isNotFunctionR = /r is not a function/i;
      const isNotFunctionError =
        error?.message?.search(isNotFunctionE) > -1 ||
        error?.message?.search(isNotFunctionP) > -1 ||
        error?.message?.search(isNotFunctionR) > -1;
      const isChunkError =
        (error?.message?.search('Loading chunk') > -1 || error?.message?.search('Loading CSS chunk') > -1) &&
        error?.message?.search('failed.') > -1;
      const correctEnvironment = getEnvironment() === PROD || getEnvironment() === PRE;

      return !isNotFunctionError && !isChunkError && correctEnvironment;
    };

    if (url && mustLogError()) {
      log(input);
    }
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      const base = getSsoUrl();
      const isChunkError =
        (error?.message?.search('Loading chunk') > -1 || error?.message?.search('Loading CSS chunk') > -1) &&
        error?.message?.search('failed.') > -1;

      if (isChunkError && base) {
        window.open(`${base}`, '_self');

        return <></>;
      }

      return <></>;
    }

    return children;
  }
}

export default ErrorBoundary;
